import { forwardRef } from "react";
import type { IconProps } from "../shared";
import { Icon } from "../icon";
/** @preview ![icon](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ3aGl0ZSIvPjxwYXRoIGZpbGw9IiMxMTE5MjgiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDRjNC40MTYgMCA4IDMuNTg0IDggOHMtMy41ODQgOC04IDgtOC0zLjU4NC04LTggMy41ODQtOCA4LThtMCAxMC42NjdhMS4zMzMgMS4zMzMgMCAxIDAgMCAyLjY2NiAxLjMzMyAxLjMzMyAwIDAgMCAwLTIuNjY2bS0uODg5LTEuNzc4VjcuNTU2aDEuNzc4djUuMzMzeiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+) */
export const IconAlertCircle = forwardRef<HTMLElement, IconProps>(
    (props, ref) => (
        <Icon ref={ref} {...props}>
            <path
                fill="#111928"
                fillRule="evenodd"
                d="M12 4c4.416 0 8 3.584 8 8s-3.584 8-8 8-8-3.584-8-8 3.584-8 8-8m0 10.667a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666m-.889-1.778V7.556h1.778v5.333z"
                clipRule="evenodd"
            />
        </Icon>
    )
);
IconAlertCircle.displayName = "IconAlertCircle";
